// What changed, newest first — and the ONE place the app's version lives.
//
// APP_VERSION is read off the first entry, so the number on screen and the
// number in the history cannot disagree. To release: add an entry at the TOP,
// and bump "version" in api/package.json to match (the server reports its own).
//
// Write for the people who USE the app, not the people who build it: what they
// can now do, not which file changed. Each text is written in all three
// languages; a missing one falls back to English.
//
// The version numbers before 1.7.0 were assigned in hindsight, from the dates
// each group of work shipped — there was no versioning before this page.
//
// type: 'new' | 'improved' | 'fixed'
export const CHANGELOG = [
  {
    version: '1.9.3',
    date: '2026-11-04',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Palleting & labels: a new tab in MIS. A label no longer needs a packing list, and labels are kept in batches: a palleting has its own number (given automatically, or type your own), a date, the loading origin, the final destination and the person responsible for the palleting, and holds its labels. A pallet code is unique: no two labels or packing lists can share one.',
          ar: 'التحزيم والملصقات: تبويب جديد في MIS. لم يعد الملصق يحتاج إلى قائمة تعبئة، وتُحفظ الملصقات في دفعات: لكل تحزيم رقمه الخاص (يُعطى تلقائياً أو اكتب رقمك)، وتاريخ، ومكان التحميل، والوجهة النهائية، والمسؤول عن التحزيم، ويضم ملصقاته. رمز الطبلية فريد: لا يشترك فيه ملصقان ولا قائمتا تعبئة.',
          fa: 'پالت‌بندی و لیبل‌ها: تب جدید در MIS. لیبل دیگر به پکینگ لیست نیاز ندارد و لیبل‌ها دسته‌ای نگه‌داری می‌شوند: هر پالت‌بندی شمارهٔ خودش را دارد (خودکار داده می‌شود یا شمارهٔ دلخواه بنویسید)، تاریخ، مبدأ بارگیری، مقصد نهایی و مسئول پالت‌بندی، و لیبل‌هایش را در خود دارد. کد پالت یکتاست: هیچ دو لیبل یا پکینگ لیستی نمی‌توانند یک کد داشته باشند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Open a palleting to see it on A4, like a packing list: its number, date, places and person, every label and every cut, with Print. Its labels are under it, one card each: print one label, all of them with a preview, or a sheet of short labels. Data shows where each label is.',
          ar: 'افتح التحزيم لتراه على ورقة A4 مثل قائمة التعبئة: رقمه وتاريخه وأماكنه والمسؤول عنه، وكل ملصق وكل قطعة، مع زر الطباعة. وتحته ملصقاته، بطاقة لكل ملصق: اطبع ملصقاً واحداً، أو كلها مع معاينة، أو ورقة ملصقات قصيرة. وتعرض «البيانات» موضع كل ملصق.',
          fa: 'پالت‌بندی را باز کنید تا آن را مانند پکینگ لیست روی A4 ببینید: شماره، تاریخ، مبدأ و مقصد و مسئول، همهٔ لیبل‌ها و همهٔ قطعه‌ها، با دکمهٔ چاپ. لیبل‌هایش زیر آن هستند، برای هر لیبل یک کارت: یک لیبل، همه با پیش‌نمایش، یا برگهٔ لیبل‌های کوتاه را چاپ کنید. «داده‌ها» نشان می‌دهد هر لیبل کجاست.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: "From a palleting" brings in its labels. Its free labels are ticked already, so one press imports them all; or tick the ones you want. The labels of one palleting can go to different packing lists, and a label is never on two lists or twice on one. A palleting can also become a packing list of its free labels in one press.',
          ar: 'قوائم التعبئة: «من تحزيم» يجلب ملصقاته. تكون ملصقاته المتاحة محددة مسبقاً، فضغطة واحدة تستوردها كلها، أو حدّد ما تريد منها. يمكن أن تذهب ملصقات تحزيم واحد إلى قوائم تعبئة مختلفة، ولا يكون الملصق في قائمتين ولا مرتين في قائمة واحدة. ويمكن تحويل التحزيم إلى قائمة تعبئة من ملصقاته المتاحة بضغطة واحدة.',
          fa: 'پکینگ لیست: «از پالت‌بندی» لیبل‌های آن را می‌آورد. لیبل‌های آزادش از قبل انتخاب شده‌اند، پس با یک کلیک همه وارد می‌شوند؛ یا هر کدام را که می‌خواهید انتخاب کنید. لیبل‌های یک پالت‌بندی می‌توانند به پکینگ لیست‌های مختلف بروند و یک لیبل هرگز در دو لیست یا دو بار در یک لیست نیست. پالت‌بندی را هم می‌توان با یک کلیک به پکینگ لیستی از لیبل‌های آزادش تبدیل کرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The Invoices section is now called MIS. On a phone its sections (Quote, Invoice, Palleting & labels, Packing lists, Requests, All) are a dropdown that names where you are, as in Digital Marketing.',
          ar: 'أصبح اسم قسم الفواتير MIS. وعلى الهاتف تظهر أقسامه (عرض السعر، الفاتورة، التحزيم والملصقات، قوائم التعبئة، الطلبات، الكل) في قائمة منسدلة تذكر أين أنت، كما في التسويق الرقمي.',
          fa: 'نام بخش فاکتورها اکنون MIS است. در گوشی، بخش‌های آن (پیش‌فاکتور، فاکتور، پالت‌بندی و لیبل‌ها، پکینگ لیست، درخواست‌ها، همه) در یک فهرست کشویی هستند که نشان می‌دهد کجا هستید، مانند دیجیتال مارکتینگ.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Labels work like packing lists and invoices: open a label to see it as it will print, and choose the slab label, the short label or a sheet of short labels, the language and the paper. Printing several labels shows the same options with a preview.',
          ar: 'تعمل الملصقات الآن مثل قوائم التعبئة والفواتير: افتح الملصق لتراه كما سيُطبع، واختر ملصق الألواح أو الملصق القصير أو ورقة الملصقات القصيرة واللغة والورق. طباعة عدة ملصقات تعرض الخيارات نفسها مع معاينة.',
          fa: 'لیبل‌ها اکنون مانند پکینگ لیست و فاکتور کار می‌کنند: لیبل را باز کنید تا آن را همان‌طور که چاپ می‌شود ببینید و لیبل اسلب، لیبل کوتاه یا برگهٔ لیبل‌های کوتاه، زبان و کاغذ را انتخاب کنید. چاپ چند لیبل هم همین گزینه‌ها را با پیش‌نمایش نشان می‌دهد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists and palletings: add labels made earlier by typing one pallet code or several. New labels can be made in both, and every label keeps one record and one pallet code.',
          ar: 'قوائم التعبئة والتحزيم: أضف ملصقات أُنشئت سابقاً بكتابة رمز طبلية واحد أو عدة رموز. يمكن إنشاء ملصقات جديدة في الاثنين، ولكل ملصق سجل واحد ورمز طبلية واحد.',
          fa: 'پکینگ لیست و پالت‌بندی: لیبل‌هایی را که قبلاً ساخته‌اید با وارد کردن یک یا چند کد پالت اضافه کنید. در هر دو می‌توان لیبل جدید ساخت و هر لیبل یک رکورد و یک کد پالت دارد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Job reports: choose in a branch\'s settings (Notifications) who is told when someone of that branch submits a report. Those people can open the report and reply, and every reply and follow-up is told to the other side, so the conversation goes back and forth.',
          ar: 'تقارير العمل: اختر في إعدادات الفرع (الإشعارات) من يُبلَّغ عندما يقدّم أحد موظفي ذلك الفرع تقريراً. يمكن لهؤلاء فتح التقرير والرد عليه، ويُبلَّغ الطرف الآخر بكل رد ومتابعة، فتستمر المحادثة ذهاباً وإياباً.',
          fa: 'گزارش‌های کار: در تنظیمات شعبه (اعلان‌ها) انتخاب کنید وقتی کسی از آن شعبه گزارشی ثبت می‌کند به چه کسانی اطلاع داده شود. این افراد می‌توانند گزارش را باز کنند و پاسخ دهند، و هر پاسخ و پیگیری به طرف دیگر اطلاع داده می‌شود تا گفت‌وگو رفت و برگشت داشته باشد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'More room for lists: the top of a section (tabs, search, filters, buttons) folds away while you scroll down and comes back as soon as you scroll up, in MIS, CRM, Supply, Digital Marketing, Inventory, File Manager, Job Reports, Tutorials, People and Report & Info.',
          ar: 'مساحة أكبر للقوائم: يُطوى الجزء العلوي من القسم (التبويبات والبحث والفلاتر والأزرار) أثناء التمرير للأسفل ويعود بمجرد التمرير للأعلى، في MIS وإدارة العملاء والتوريد والتسويق الرقمي والمخزون ومدير الملفات وتقارير العمل والدروس والأشخاص والتقارير والمعلومات.',
          fa: 'جای بیشتر برای فهرست‌ها: بالای هر بخش (تب‌ها، جست‌وجو، فیلترها و دکمه‌ها) هنگام اسکرول به پایین جمع می‌شود و با اسکرول به بالا فوراً برمی‌گردد؛ در MIS، CRM، تأمین، دیجیتال مارکتینگ، انبار، مدیریت فایل، گزارش‌های کار، آموزش‌ها، افراد و گزارش و اطلاعات.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Labels: the list, opening a pallet and switching its label or language are much quicker, and Print sends the label already on screen.',
          ar: 'الملصقات: أصبحت القائمة وفتح الطبلية وتبديل نوع الملصق أو لغته أسرع بكثير، ويطبع زر الطباعة الملصق المعروض على الشاشة نفسه.',
          fa: 'لیبل‌ها: فهرست، باز کردن پالت و عوض کردن نوع یا زبان لیبل بسیار سریع‌تر شده و دکمهٔ چاپ همان لیبلی را که روی صفحه است چاپ می‌کند.',
        },
      },
    ],
  },
  {
    version: '1.9.2',
    date: '2026-10-31',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Printed documents now open in the language you chose for the app: invoices, quotations, packing lists, labels, the collective list and daily reports. You can still pick another language beside Print for that one document.',
          ar: 'تُفتح المستندات المطبوعة الآن باللغة التي اخترتها للتطبيق: الفواتير وعروض الأسعار وقوائم التعبئة والملصقات والقائمة المجمعة والتقارير اليومية. ويمكنك اختيار لغة أخرى بجانب زر الطباعة لذلك المستند فقط.',
          fa: 'اسناد چاپی اکنون با زبانی که برای برنامه انتخاب کرده‌اید باز می‌شوند: فاکتورها، پیش‌فاکتورها، پکینگ لیست‌ها، برچسب‌ها، لیست تجمیعی و گزارش‌های روزانه. همچنان می‌توانید کنار دکمهٔ چاپ زبان دیگری را فقط برای همان سند انتخاب کنید.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing lists: the sort S is now E (Q, E or W). Lists saved with S read as E everywhere, on screen, on paper and in the filters.',
          ar: 'قوائم التعبئة: أصبح التصنيف S هو E (Q أو E أو W). القوائم المحفوظة بالحرف S تظهر E في كل مكان، على الشاشة وعلى الورق وفي المرشحات.',
          fa: 'پکینگ لیست: سورت S اکنون E است (Q، E یا W). لیست‌هایی که با S ذخیره شده‌اند همه‌جا E نمایش داده می‌شوند، روی صفحه، روی کاغذ و در فیلترها.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Packing lists: the sheet of short labels now asks which paper is in the printer. On A5 all five labels stay whole, whatever paper the print window shows; on A4 they print at full size.',
          ar: 'قوائم التعبئة: تسأل ورقة الملصقات القصيرة الآن عن الورق الموجود في الطابعة. على A5 تبقى الملصقات الخمسة كاملة أيًا كان الورق في نافذة الطباعة، وعلى A4 تُطبع بالحجم الكامل.',
          fa: 'پکینگ لیست: برگهٔ برچسب‌های کوتاه اکنون می‌پرسد چه کاغذی در چاپگر است. روی A5 هر پنج برچسب کامل می‌مانند، کاغذ پنجرهٔ چاپ هر چه باشد؛ روی A4 با اندازهٔ کامل چاپ می‌شوند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Job reports: a salesperson\'s report now opens as the daily sheet the sales team uses, with confirmed orders and collections on one side and orders not closed, follow-ups and notes on the other. Show and print it in English, Arabic or Persian: what you see is exactly what prints.',
          ar: 'التقارير اليومية: يُفتح تقرير المندوب الآن على شكل التقرير اليومي الذي يستخدمه فريق المبيعات، الطلبات المؤكدة والتحصيلات في جهة، والطلبات التي لم تُغلق والمتابعات والملاحظات في الجهة الأخرى. اعرضه واطبعه بالإنجليزية أو العربية أو الفارسية: ما تراه هو بالضبط ما يُطبع.',
          fa: 'گزارش روزانه: گزارش فروشنده اکنون به شکل برگهٔ روزانهٔ تیم فروش باز می‌شود؛ سفارش‌های قطعی و وصولی‌ها در یک طرف و سفارش‌های بسته‌نشده، پیگیری‌ها و یادداشت‌ها در طرف دیگر. آن را به انگلیسی، عربی یا فارسی ببینید و چاپ کنید: همان چیزی که می‌بینید چاپ می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: the Collective list, the table icon beside New packing list. One row per packing list, like the register kept in a spreadsheet: date, destination, origin, stone, dimensions, pallets, area, invoice, exit and packing numbers, trailer plate, contact, driver and loading officer. Choose the columns, sort by clicking a heading, use the same search, time frames and filters as the list, and print exactly what is on screen, in English, Arabic or Persian, whatever language the app is in.',
          ar: 'قوائم التعبئة: القائمة المجمعة، أيقونة الجدول بجانب زر قائمة تعبئة جديدة. صف لكل قائمة تعبئة، مثل السجل الذي كان يُحفظ في جدول بيانات: التاريخ والوجهة والمنشأ والحجر والأبعاد والطبالي والمساحة وأرقام الفاتورة والخروج والتعبئة ولوحة المقطورة والاتصال والسائق ومسؤول التحميل. اختر الأعمدة، ورتّب بالنقر على العنوان، واستخدم البحث والفترات الزمنية والمرشحات نفسها، واطبع ما تراه على الشاشة تمامًا بالإنجليزية أو العربية أو الفارسية، أيًا كانت لغة التطبيق.',
          fa: 'پکینگ لیست: لیست تجمیعی، آیکون جدول کنار دکمهٔ پکینگ لیست جدید. برای هر پکینگ لیست یک ردیف، مثل دفتری که در اکسل نگه داشته می‌شد: تاریخ، مقصد، مبدا، سنگ، ابعاد، پالت، متراژ، شماره‌های فاکتور و خروج و پکینگ، پلاک تریلی، تماس، راننده و ناظر بارگیری. ستون‌ها را انتخاب کنید، با کلیک روی عنوان مرتب کنید، از همان جستجو و بازهٔ زمانی و فیلترها استفاده کنید و دقیقاً همان چیزی را که روی صفحه است به انگلیسی، عربی یا فارسی چاپ کنید، زبان برنامه هر چه باشد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: pallet templates. Press the bookmark on a pallet to keep it as a template, then use Add from template in any packing list of the branch. Say how many pallets you want (30 from one template, for example, up to 100 at a time): each gets the rows of the template with its own ID and pallet code.',
          ar: 'قوائم التعبئة: قوالب الطبالي. اضغط علامة الحفظ في طبلية لتحفظها كقالب، ثم استخدم «إضافة من قالب» في أي قائمة تعبئة في الفرع. حدد عدد الطبالي المطلوب (30 من قالب واحد مثلًا، حتى 100 في المرة): تأخذ كل طبلية صفوف القالب مع معرّفها ورمزها الخاصين.',
          fa: 'پکینگ لیست: قالب پالت. نشانهٔ روی یک پالت را بزنید تا به‌عنوان قالب نگه داشته شود، سپس در هر پکینگ لیست این شعبه از «افزودن از قالب» استفاده کنید. تعداد پالت را مشخص کنید (مثلاً 30 پالت از یک قالب، تا 100 پالت در هر بار): هر پالت ردیف‌های قالب را با شناسه و کد پالت خودش می‌گیرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'A pallet code is now unique across all packing lists of all branches. Leave it empty and it takes the next free number when you save; the numbers start at 03000. You can still type your own, as long as no other list has it. An exit number can be added to a packing list.',
          ar: 'صار رمز الطبلية فريدًا في جميع قوائم التعبئة في كل الفروع. اتركه فارغًا ليأخذ الرقم المتاح التالي عند الحفظ؛ وتبدأ الأرقام من 03000. ويمكنك كتابة رمزك الخاص ما دام غير مستخدم في قائمة أخرى. ويمكن إضافة رقم خروج إلى قائمة التعبئة.',
          fa: 'کد پالت حالا در همهٔ پکینگ لیست‌های همهٔ شعبه‌ها یکتاست. اگر خالی بماند، هنگام ذخیره شمارهٔ آزاد بعدی را می‌گیرد؛ شماره‌ها از 03000 شروع می‌شوند. همچنان می‌توانید کد خودتان را بنویسید، به شرطی که در لیست دیگری نباشد. می‌توان به پکینگ لیست شماره خروج هم اضافه کرد.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Short labels sheet: the sheet no longer insists on A4, which is what cut the pallet number, the big letter and the last label off the paper when the printer was on a smaller size. It now fits the paper chosen in the print window: full size on A4, smaller but complete on A5. Choose the size that is in the printer.',
          ar: 'ورقة الملصقات القصيرة: لم تعد الورقة تفرض A4، وهو ما كان يقطع رقم الطبلية والحرف الكبير وآخر ملصق عندما تكون الطابعة على مقاس أصغر. صارت تتوافق مع الورق المختار في نافذة الطباعة: بالحجم الكامل على A4، وأصغر لكن كاملة على A5. اختر المقاس الموجود في الطابعة.',
          fa: 'برگهٔ برچسب‌های کوتاه: برگه دیگر A4 را تحمیل نمی‌کند؛ همین باعث می‌شد وقتی چاپگر روی اندازهٔ کوچک‌تری بود، شمارهٔ پالت، حرف بزرگ و آخرین برچسب از کاغذ بیرون بمانند. حالا با کاغذی که در پنجرهٔ چاپ انتخاب می‌کنید هماهنگ می‌شود: روی A4 اندازهٔ کامل، روی A5 کوچک‌تر ولی کامل. اندازه‌ای را انتخاب کنید که در چاپگر است.',
        },
      },
    ],
  },
  {
    version: '1.9.1',
    date: '2026-10-28',
    changes: [
      {
        type: 'new',
        text: {
          en: 'File Manager: every file and folder has its own menu button (the three dots at the bottom right of its card, or a right click / long press) with Open or Preview, Details, Rename, Cut, Copy, Paste into, Move to, Download, Share, Pin, Select and Delete - only the ones you are allowed to use. Cut or Copy as many items as you like, go to any folder and press Paste in the bar that appears; a cut item moves, a copied one stays where it was.',
          ar: 'مدير الملفات: لكل ملف ومجلد زر قائمة خاص به (النقاط الثلاث أسفل يمين بطاقته، أو النقر الأيمن / الضغط المطوّل) فيه فتح أو معاينة وتفاصيل وإعادة تسمية وقص ونسخ ولصق داخله ونقل إلى وتنزيل ومشاركة وتثبيت وتحديد وحذف - المسموح لك منها فقط. اقصّ أو انسخ ما تشاء من العناصر، ثم انتقل إلى أي مجلد واضغط «لصق» في الشريط الذي يظهر؛ العنصر المقصوص ينتقل والمنسوخ يبقى في مكانه.',
          fa: 'مدیر فایل: هر فایل و پوشه دکمهٔ منوی خودش را دارد (سه نقطه در پایین سمت راست کارت، یا کلیک راست / نگه داشتن) با باز کردن یا پیش‌نمایش، جزئیات، تغییر نام، برش، کپی، چسباندن داخل، انتقال به، دانلود، اشتراک‌گذاری، سنجاق، انتخاب و حذف - فقط مواردی که اجازه‌اش را دارید. هر تعداد مورد را برش یا کپی کنید، به هر پوشه بروید و در نواری که ظاهر می‌شود «چسباندن» را بزنید؛ مورد بریده‌شده جابه‌جا می‌شود و کپی‌شده سر جایش می‌ماند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Pallet labels (the large A5 label): the pallet\'s processing type is now printed in the grey Total row, under the # and Code columns. A pallet with no processing type prints exactly as before.',
          ar: 'ملصقات الطبلية (الملصق الكبير A5): يُطبع الآن نوع المعالجة الخاص بالطبلية في صف «المجموع» الرمادي، تحت عمودَي # والرمز. والطبلية التي ليس لها نوع معالجة تُطبع تمامًا كما كانت.',
          fa: 'برچسب پالت (برچسب بزرگ A5): «وضعیت فرآوری» پالت حالا در ردیف خاکستری «جمع»، زیر ستون‌های # و کد چاپ می‌شود. پالتی که وضعیت فرآوری ندارد دقیقاً مثل قبل چاپ می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'File Manager on a phone: Rename is now in the bar at the top when one item is selected, next to Cut, Copy and Delete; the rest (download, move, copy to, share, tag, select all) are under its three dots. The bar stays in view while you scroll.',
          ar: 'مدير الملفات على الهاتف: صار زر إعادة التسمية في الشريط العلوي عند تحديد عنصر واحد، بجانب قص ونسخ وحذف؛ وبقية الأوامر (تنزيل ونقل ونسخ إلى ومشاركة ووسم وتحديد الكل) تحت نقاطه الثلاث. ويبقى الشريط ظاهرًا أثناء التمرير.',
          fa: 'مدیر فایل در گوشی: وقتی یک مورد انتخاب شده، «تغییر نام» در نوار بالا کنار برش، کپی و حذف است؛ بقیه (دانلود، انتقال، کپی به، اشتراک‌گذاری، برچسب، انتخاب همه) زیر سه نقطهٔ آن است. نوار هنگام اسکرول در دید می‌ماند.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'File Manager: a file moved or copied into a folder no longer disappears. It stayed in the database but was listed nowhere, so it looked deleted; every folder now shows what its items say they belong to, and files that had already vanished this way show again. Also fixed: copying a file to the top level reported an error after making the copy; a folder could be moved into itself, which cut it off from the tree; a folder copied next to its original got the same name; moving a folder did not update the lists the zip download and the share page use. Ask your administrator to run "node scripts/repairFolderLists.js" once to tidy the stored lists.',
          ar: 'مدير الملفات: لم يعد الملف الذي يُنقل أو يُنسخ إلى مجلد يختفي. كان يبقى في قاعدة البيانات لكنه غير مدرج في أي مكان فيبدو محذوفًا؛ والآن يعرض كل مجلد ما تقول عناصره إنها تنتمي إليه، وتظهر من جديد الملفات التي اختفت بهذه الطريقة. وأُصلح أيضًا: نسخ ملف إلى المستوى الأعلى كان يعرض خطأ بعد إتمام النسخ؛ وكان يمكن نقل مجلد إلى داخل نفسه فينقطع عن الشجرة؛ والمجلد المنسوخ بجوار أصله كان يحمل الاسم نفسه؛ ونقل المجلد لم يكن يحدّث القوائم التي يستخدمها التنزيل المضغوط وصفحة المشاركة. اطلب من المسؤول تشغيل «node scripts/repairFolderLists.js» مرة واحدة لترتيب القوائم المخزّنة.',
          fa: 'مدیر فایل: فایلی که به یک پوشه منتقل یا کپی می‌شد دیگر ناپدید نمی‌شود. در پایگاه داده می‌ماند اما در هیچ فهرستی نبود و حذف‌شده به نظر می‌رسید؛ حالا هر پوشه همان چیزی را نشان می‌دهد که موردهایش می‌گویند به آن تعلق دارند و فایل‌هایی که قبلاً این‌طور گم شده بودند دوباره دیده می‌شوند. همچنین درست شد: کپی فایل به سطح اصلی پس از ساختن کپی خطا نشان می‌داد؛ می‌شد پوشه‌ای را داخل خودش برد و از درخت جدا می‌شد؛ پوشهٔ کپی‌شده کنار اصلی‌اش همان نام را می‌گرفت؛ انتقال پوشه فهرست‌هایی را که دانلود زیپ و صفحهٔ اشتراک استفاده می‌کنند به‌روز نمی‌کرد. از مدیر بخواهید یک بار «node scripts/repairFolderLists.js» را اجرا کند تا فهرست‌های ذخیره‌شده مرتب شوند.',
        },
      },
    ],
  },
  {
    version: '1.9.0',
    date: '2026-10-28',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Calendar and calculator on every screen. Press F5 for a floating calendar (Gregorian, Shamsi or Hijri: pick a day or a range and see it in all three) and F6 for a calculator. Drag them by the title bar, resize them from any edge, and keep them open while you move between sections or fill in a form. On a phone they are in the menu under Tools and open as a page over what you are doing; closing it, or pressing Back, returns you exactly where you were. F5 no longer reloads the page (Ctrl+F5 still does).',
          ar: 'التقويم والآلة الحاسبة في كل الشاشات. اضغط F5 لتقويم عائم (ميلادي أو شمسي أو هجري: اختر يومًا أو نطاقًا وشاهده في التقاويم الثلاثة) وF6 لآلة حاسبة. حرّكهما من شريط العنوان وغيّر حجمهما من أي حافة، وأبقهما مفتوحتين وأنت تنتقل بين الأقسام أو تملأ نموذجًا. على الهاتف تجدهما في القائمة تحت «الأدوات» وتُفتحان كصفحة فوق ما تعمل عليه؛ وعند إغلاقها أو الضغط على زر الرجوع تعود إلى مكانك تمامًا. لم يعد F5 يعيد تحميل الصفحة (ما زال Ctrl+F5 يفعل ذلك).',
          fa: 'تقویم و ماشین‌حساب در همهٔ صفحه‌ها. با F5 تقویم شناور (میلادی، شمسی یا هجری؛ یک روز یا یک بازه را انتخاب کنید و در هر سه تقویم ببینید) و با F6 ماشین‌حساب باز می‌شود. آن‌ها را با نوار عنوان جابه‌جا کنید، از هر لبه تغییر اندازه دهید و هنگام رفتن به بخش دیگر یا پر کردن فرم بازشان بگذارید. در گوشی در منو زیر «ابزارها» هستند و مثل یک صفحه روی کار شما باز می‌شوند؛ با بستن آن یا زدن دکمهٔ برگشت دقیقاً به جای قبلی برمی‌گردید. F5 دیگر صفحه را دوباره بارگذاری نمی‌کند (Ctrl+F5 همچنان می‌کند).',
        },
      },
      {
        type: 'new',
        text: {
          en: 'The calendar can filter the screen you are on: pick a day or a range and press "Apply to ..." on Invoices, Packing Lists, Customers (last call date), Supply, Raw Contents, Ready to Upload or Job Reports.',
          ar: 'يستطيع التقويم تصفية الشاشة التي أنت فيها: اختر يومًا أو نطاقًا واضغط «تطبيق على…» في الفواتير وقوائم التعبئة والعملاء (تاريخ آخر اتصال) والتوريد والمحتوى الخام والجاهز للرفع وتقارير العمل.',
          fa: 'تقویم می‌تواند صفحه‌ای را که در آن هستید فیلتر کند: یک روز یا یک بازه را انتخاب کنید و در فاکتورها، پکینگ لیست‌ها، مشتریان (تاریخ آخرین تماس)، تأمین، محتوای خام، آمادهٔ آپلود و گزارش‌های کار «اعمال روی …» را بزنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'The calculator works like the Windows Calculator: the same keys (Enter, Esc to clear, Delete to clear the entry, F9, R, @, Ctrl+M / P / Q / R / L for memory, Ctrl+C and Ctrl+V) and the same keypad, with the square root, square, 1/x, plus-minus and a memory row. Its keys work the moment you open it, even with a form open underneath, until you click or move to another field. Closing and reopening it, moving between sections, or reloading the page never erases the sum, the memory, the history or the calendar.',
          ar: 'تعمل الآلة الحاسبة مثل آلة ويندوز الحاسبة: المفاتيح نفسها (Enter وEsc للمسح وDelete لمسح الإدخال وF9 وR و@ وCtrl+M/P/Q/R/L للذاكرة وCtrl+C وCtrl+V) ولوحة المفاتيح نفسها مع الجذر التربيعي والتربيع و1/x وتغيير الإشارة وصف الذاكرة. وتعمل مفاتيحها فور فتحها حتى لو كان هناك نموذج مفتوح تحتها، إلى أن تنقر أو تنتقل إلى حقل آخر. وإغلاقها وإعادة فتحها أو التنقل بين الأقسام أو إعادة تحميل الصفحة لا يمسح العملية الحسابية ولا الذاكرة ولا السجل ولا التقويم.',
          fa: 'ماشین‌حساب مثل ماشین‌حساب ویندوز کار می‌کند: همان کلیدها (Enter، Esc برای پاک کردن همه، Delete برای پاک کردن ورودی، F9، R، @، Ctrl+M/P/Q/R/L برای حافظه، Ctrl+C و Ctrl+V) و همان صفحه‌کلید با جذر، توان دوم، 1/x، تغییر علامت و ردیف حافظه. کلیدهایش همان لحظه که باز می‌شود کار می‌کنند، حتی وقتی زیرش فرمی باز است، تا وقتی که روی جای دیگری کلیک کنید یا به فیلد دیگری بروید. بستن و باز کردن دوباره، رفتن به بخش دیگر یا بارگذاری دوبارهٔ صفحه، محاسبه، حافظه، تاریخچه و تقویم را پاک نمی‌کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Short pallet labels: the big letter at the right is now the sort picked on the packing list row (Q, S or W); when no sort was picked it is still the grade in the variety code.',
          ar: 'ملصقات الطبلية القصيرة: الحرف الكبير على اليمين هو الآن النوع المختار في صف قائمة التعبئة (Q أو S أو W)؛ وإن لم يُختر نوع فهو درجة رمز الصنف كما كان.',
          fa: 'برچسب پالت کوتاه: حرف درشت سمت راست حالا همان «نوع» انتخاب‌شده در ردیف پکینگ لیست است (Q یا S یا W)؛ اگر نوعی انتخاب نشده باشد مثل قبل درجهٔ کد سنگ است.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Short pallet labels on an A4 sheet: every label is now exactly the size it has on a full sheet of five (with fewer than five labels they used to come out taller), and five labels always fit on one sheet even when each has two, three or four rows - only the rows get a little shorter (a label with two rows used to be taller, so just three fitted on a page). A label with five or more rows takes two places on the sheet.',
          ar: 'ملصقات الطبلية القصيرة على ورقة A4: أصبح كل ملصق بالحجم نفسه تمامًا الذي يكون عليه في ورقة كاملة من خمسة (كان يخرج أطول عند طباعة أقل من خمسة)، وصارت الملصقات الخمسة تتسع دائمًا في ورقة واحدة حتى لو كان لكل منها صفان أو ثلاثة أو أربعة؛ فقط تصبح الصفوف أقصر قليلًا (كان الملصق ذو الصفين أطول فلا يتسع إلا ثلاثة في الصفحة). والملصق ذو خمسة صفوف أو أكثر يشغل مكانين في الورقة.',
          fa: 'برچسب پالت کوتاه روی برگهٔ A4: حالا هر برچسب دقیقاً به اندازه‌ای است که روی برگهٔ کامل پنج‌تایی دارد (با کمتر از پنج برچسب بلندتر درمی‌آمد) و پنج برچسب همیشه روی یک برگه جا می‌شوند، حتی وقتی هر کدام دو، سه یا چهار ردیف دارند؛ فقط ردیف‌ها کمی کوتاه‌تر می‌شوند (قبلاً برچسب دوردیفی بلندتر بود و در هر صفحه فقط سه تا جا می‌شد). برچسبی که پنج ردیف یا بیشتر دارد دو جای برگه را می‌گیرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing lists: the area calculated from L x W x pieces, and every total, now has four decimals (17.2800), and it is calculated again every time L, W or the number of pieces changes - even on a row where you typed an area, or one opened from a saved list. The area box in the form is wider, so the whole number shows.',
          ar: 'قوائم التعبئة: المساحة المحسوبة من الطول × العرض × العدد وكل الإجماليات أصبحت بأربع خانات عشرية (17.2800)، وتُحسب من جديد كلما تغيّر الطول أو العرض أو عدد القطع، حتى في صف كتبت فيه المساحة بيدك أو فتحته من قائمة محفوظة. وصار حقل المساحة في النموذج أعرض فيظهر الرقم كاملًا.',
          fa: 'پکینگ لیست: متراژ محاسبه‌شده از طول × عرض × تعداد و همهٔ جمع‌ها حالا چهار رقم اعشار دارند (17.2800) و با هر تغییر طول، عرض یا تعداد دوباره محاسبه می‌شوند، حتی در ردیفی که متراژ را دستی نوشته‌اید یا از لیست ذخیره‌شده باز کرده‌اید. کادر متراژ در فرم هم عریض‌تر شد تا عدد کامل دیده شود.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Customers: filtering by the last call date for a single day, or for a range ending today, found nothing. The end day is now included.',
          ar: 'العملاء: كانت التصفية بتاريخ آخر اتصال ليوم واحد، أو لنطاق ينتهي اليوم، لا تعثر على شيء. أصبح يوم النهاية مشمولًا الآن.',
          fa: 'مشتریان: فیلتر تاریخ آخرین تماس برای یک روز، یا بازه‌ای که امروز تمام می‌شود، چیزی پیدا نمی‌کرد. حالا روز پایان هم حساب می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.9',
    date: '2026-10-25',
    changes: [
      {
        type: 'fixed',
        text: {
          en: 'Packing list: a long list could lose rows when you saved it. Rows with no stone code (only sizes and counts) were being left out without a word, and so was a pallet with rows but no ID. Every row you type is now saved, a pallet that has rows but no ID is pointed out instead of dropped, and a new list starts with its first pallet already called P1.',
          ar: 'قائمة التعبئة: كانت القائمة الطويلة قد تفقد بعض صفوفها عند الحفظ. فالصفوف التي بلا رمز حجر (أبعاد وأعداد فقط) كانت تُترك دون أي تنبيه، وكذلك الطبلية التي فيها صفوف بلا رقم تعريف. أصبحت كل الصفوف التي تكتبها تُحفظ، والطبلية التي فيها صفوف بلا رقم تعريف يتم التنبيه عليها بدل حذفها، وتبدأ القائمة الجديدة بطبلية أولى اسمها P1.',
          fa: 'پکینگ لیست: یک لیست بلند هنگام ذخیره ممکن بود بخشی از ردیف‌هایش را از دست بدهد. ردیف‌هایی که شناسه سنگ نداشتند (فقط ابعاد و تعداد) بی‌صدا کنار گذاشته می‌شدند، پالتی که ردیف داشت ولی شناسه نداشت هم همین‌طور. حالا هر ردیفی که می‌نویسید ذخیره می‌شود، پالتی که ردیف دارد اما شناسه ندارد تذکر می‌دهد به‌جای اینکه حذف شود، و لیست تازه با پالت اول به نام P1 شروع می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Forms with many fields - a long packing list above all - now open and save several times faster.',
          ar: 'صارت النماذج التي فيها حقول كثيرة - وفي مقدمتها قائمة التعبئة الطويلة - تُفتح وتُحفظ أسرع بعدة مرات.',
          fa: 'فرم‌هایی که فیلد زیادی دارند - به‌ویژه یک پکینگ لیست بلند - حالا چند برابر سریع‌تر باز و ذخیره می‌شوند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Arabic is now written in Amiri and Persian in B Nazanin everywhere - in every language of the app, including English, and on every printed document (invoices, quotations, packing lists, labels, reports). A Persian name inside an Arabic screen, or an Arabic one inside a Persian screen, gets its own font too.',
          ar: 'صارت الكتابة العربية بخط «أميري» والفارسية بخط «بی نازنین» في كل مكان - بكل لغات التطبيق بما فيها الإنجليزية، وفي كل مستند مطبوع (الفواتير وعروض الأسعار وقوائم التعبئة والملصقات والتقارير). وحتى الاسم الفارسي داخل شاشة عربية، أو العربي داخل شاشة فارسية، يأخذ خطه الخاص.',
          fa: 'حالا عربی با فونت «امیری» و فارسی با فونت «بی نازنین» در همه‌جا نوشته می‌شود - در همهٔ زبان‌های برنامه از جمله انگلیسی، و روی همهٔ چاپ‌ها (فاکتور، پیش‌فاکتور، پکینگ لیست، لیبل و گزارش‌ها). حتی یک نام فارسی داخل صفحهٔ عربی، یا نام عربی داخل صفحهٔ فارسی هم فونت مخصوص خودش را می‌گیرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Lists are easier to read: every second record - customers, invoices and quotations, requests, packing lists, supply records, products, users and more - sits on a slightly different shade, so the eye can stay on one row.',
          ar: 'صارت القوائم أسهل قراءة: كل سجل ثانٍ - العملاء والفواتير وعروض الأسعار والطلبات وقوائم التعبئة وسجلات التوريد والمنتجات والمستخدمون وغيرها - يظهر بدرجة لون مختلفة قليلًا ليتتبع النظر الصف الواحد.',
          fa: 'خواندن لیست‌ها راحت‌تر شد: یکی در میان رکوردها - مشتری‌ها، فاکتور و پیش‌فاکتور، درخواست‌ها، پکینگ لیست‌ها، رکوردهای تأمین، محصولات، کاربران و بیشتر - کمی با رنگ متفاوت نمایش داده می‌شوند تا چشم بتواند یک ردیف را دنبال کند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: search now looks in every field of the form - driver, loading officer, customs agent, loading origin, final destination, notes, stone names, pallet and stone codes, sizes, even invoice numbers - and every word you type must be found. Type # and a number to find a document number.',
          ar: 'قوائم التعبئة: صار البحث يشمل كل حقول النموذج - السائق، مسؤول التحميل، مندوب التخليص، مبدأ الشحن، الوجهة النهائية، الملاحظات، أسماء الأحجار، رموز الطبليات والأحجار، الأبعاد وحتى أرقام الفواتير - ويجب أن تُوجد كل كلمة تكتبها. اكتب # ثم رقمًا للبحث عن رقم مستند.',
          fa: 'پکینگ لیست: جستجو حالا در همهٔ فیلدهای فرم انجام می‌شود - راننده، مسئول بارگیری، نمایندهٔ گمرک، مبدأ بارگیری، مقصد نهایی، توضیحات، نام سنگ، کد پالت و شناسه سنگ، ابعاد و حتی شمارهٔ فاکتور - و هر کلمه‌ای که بنویسید باید پیدا شود. برای پیدا کردن شمارهٔ سند، # و عدد را بنویسید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: a new Filters button. Choose a time frame the easy way (Today, Last 7 days, This month, Last month, This year, or your own From / To in the calendar you prefer), the status, and then pick from what your lists already hold: every loading officer, customs agent, driver, loading origin, final destination, stone name and more, each with how many lists it has. Pick a name and only those lists stay; the chips above the list show what is filtered and remove it with one tap.',
          ar: 'قوائم التعبئة: زر جديد للمرشحات. اختر الفترة الزمنية بسهولة (اليوم، آخر 7 أيام، هذا الشهر، الشهر الماضي، هذه السنة، أو من/إلى بالتقويم الذي تفضله)، ثم الحالة، ثم اختر مما تحتويه قوائمك فعلًا: كل مسؤول تحميل ومندوب تخليص وسائق ومبدأ شحن ووجهة نهائية واسم حجر وغيرها، مع عدد القوائم لكل منها. اختر اسمًا فتبقى قوائمه فقط، وتُظهر الشارات فوق القائمة ما تمت تصفيته وتُزيله بنقرة واحدة.',
          fa: 'پکینگ لیست: دکمهٔ تازهٔ فیلترها. بازهٔ زمانی را راحت انتخاب کنید (امروز، ۷ روز گذشته، این ماه، ماه گذشته، امسال، یا «از / تا» در تقویمی که دوست دارید)، سپس وضعیت، و بعد از میان آنچه لیست‌هایتان از قبل دارند انتخاب کنید: هر مسئول بارگیری، نمایندهٔ گمرک، راننده، مبدأ بارگیری، مقصد نهایی، نام سنگ و بیشتر، هرکدام با تعداد لیست‌هایش. یک نام را انتخاب کنید تا فقط لیست‌های آن بماند؛ برچسب‌های بالای لیست نشان می‌دهند چه چیزی فیلتر شده و با یک ضربه برش می‌دارند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: the sheet of short labels now uses the whole page. The labels are taller and evenly spaced, so five of them fill an A4 sheet instead of stopping two-thirds of the way down, and the text on them is heavier and easier to read.',
          ar: 'قائمة التعبئة: صارت ورقة الملصقات القصيرة تستخدم الصفحة كلها. الملصقات أطول ومتباعدة بالتساوي، فتملأ خمسة منها ورقة A4 بدل أن تتوقف عند ثلثيها، والنص عليها أثقل وأسهل قراءة.',
          fa: 'پکینگ لیست: برگهٔ لیبل‌های کوتاه حالا کل صفحه را پر می‌کند. لیبل‌ها بلندتر و با فاصلهٔ یکسان‌اند، پس پنج لیبل یک برگ A4 را پر می‌کنند و در دو سومِ آن متوقف نمی‌شوند، و نوشتهٔ روی آن‌ها پررنگ‌تر و خواناتر است.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: every row of a pallet now has its own number (No), in the form and in the saved record, counting from 1 inside each pallet and following the order as rows are added, inserted or removed. Every second row is shaded a little, so the eye can stay on one row across all its cells.',
          ar: 'قائمة التعبئة: صار لكل صف في الطبلية رقمه الخاص (الرقم) في النموذج وفي القائمة المحفوظة، يبدأ من 1 داخل كل طبلية ويتبع الترتيب عند إضافة الصفوف أو إدراجها أو حذفها. ويُظلَّل كل صف ثانٍ قليلًا ليتتبع النظر الصف الواحد عبر كل خلاياه.',
          fa: 'پکینگ لیست: هر ردیف از پالت حالا شمارهٔ خودش (ردیف) را دارد، هم در فرم و هم در لیست ذخیره‌شده؛ از ۱ داخل هر پالت شروع می‌شود و با اضافه، درج یا حذف ردیف‌ها خودش را با ترتیب هماهنگ می‌کند. یکی در میان هم ردیف‌ها کمی تیره‌تر می‌شوند تا چشم بتواند یک ردیف را در میان همهٔ خانه‌هایش دنبال کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: the large pallet label no longer shows the loading origin. It shows the destination only; the origin is still on the packing list itself.',
          ar: 'قائمة التعبئة: لم يعد ملصق الطبلية الكبير يعرض مبدأ الشحن. يعرض الوجهة فقط، ويبقى المبدأ ظاهرًا في قائمة التعبئة نفسها.',
          fa: 'پکینگ لیست: لیبل بزرگ پالت دیگر مبدأ بارگیری را نشان نمی‌دهد و فقط مقصد را می‌نویسد؛ مبدأ همچنان روی خود پکینگ لیست چاپ می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.8',
    date: '2026-10-25',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Packing list: the loading origin and the final destination are now picked from a list your branch builds up. If the place you need is not there, type it and press Enter to add it — it is in the list from then on. Pressing Enter on the field before opens the origin list, the arrow keys walk it, and Enter picks a place and moves straight on to the destination list.',
          ar: 'قائمة التعبئة: صار مبدأ الشحن والوجهة النهائية يُختاران من قائمة يبنيها فرعك. وإن لم يكن المكان المطلوب موجودًا، اكتبه واضغط Enter لإضافته فيبقى في القائمة بعدها. والضغط على Enter في الحقل السابق يفتح قائمة المبدأ، وتتنقل بين الأماكن بالأسهم، ويختار Enter المكان وينتقل مباشرة إلى قائمة الوجهة.',
          fa: 'پکینگ لیست: مبدأ بارگیری و مقصد نهایی حالا از لیستی انتخاب می‌شوند که شعبهٔ خودتان می‌سازد. اگر مکان مورد نظر در لیست نبود، آن را بنویسید و Enter بزنید تا اضافه شود و از آن پس در لیست بماند. زدن Enter در فیلد قبلی لیست مبدأ را باز می‌کند، با کلیدهای جهت‌نما بین مکان‌ها حرکت می‌کنید و Enter مکان را انتخاب می‌کند و مستقیم به لیست مقصد می‌رود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list: every row of a pallet now has a Sort (Q, S or W), chosen from a list. Enter opens the list, the arrow keys walk it, and Enter picks one and moves on to the next cell. It prints on the packing list beside the stone code.',
          ar: 'قائمة التعبئة: صار لكل صف في الطبلية تصنيف (Q أو S أو W) يُختار من قائمة. يفتح Enter القائمة، وتتنقل فيها بالأسهم، ويختار Enter عنصرًا وينتقل إلى الخلية التالية. ويُطبع على قائمة التعبئة بجانب رمز الحجر.',
          fa: 'پکینگ لیست: هر ردیف از پالت حالا یک سورت (Q، S یا W) دارد که از یک لیست انتخاب می‌شود. Enter لیست را باز می‌کند، با کلیدهای جهت‌نما در آن حرکت می‌کنید و Enter یکی را انتخاب می‌کند و به خانهٔ بعد می‌رود. سورت کنار شناسه سنگ روی پکینگ لیست چاپ می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: a pallet can be filled without leaving the keyboard. Insert adds a pallet and puts the cursor in it, and Enter on the last cell of a row inserts a new row right after it and puts the cursor in its stone code. Removing a place from the origin or destination list now asks you to confirm first.',
          ar: 'قائمة التعبئة: يمكن ملء الطبلية دون مغادرة لوحة المفاتيح. فمفتاح Insert يضيف طبلية ويضع المؤشر فيها، و Enter في آخر خلية من الصف يُدرج صفًا جديدًا بعده مباشرة ويضع المؤشر في رمز حجره. وصار حذف مكان من قائمة المبدأ أو الوجهة يطلب منك التأكيد أولًا.',
          fa: 'پکینگ لیست: یک پالت را می‌شود بدون ترک صفحه‌کلید پر کرد. کلید Insert یک پالت اضافه می‌کند و مکان‌نما را در آن می‌گذارد، و Enter روی آخرین خانهٔ یک ردیف، یک ردیف جدید درست بعد از آن می‌سازد و مکان‌نما را در شناسه سنگ آن می‌گذارد. حذف یک مکان از لیست مبدأ یا مقصد هم حالا اول تأیید می‌گیرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: the names on the form follow what people call these things — a pallet\u2019s “Reference” is now its “Pallet code”, and a row\u2019s “Code” is its “Stone code”. The driver\u2019s national ID and smart number are one field, and the driver\u2019s bank IBAN and the phone numbers of the loading officer and the customs agent are no longer asked for. A list saved before this keeps everything it was saved with.',
          ar: 'قائمة التعبئة: صارت التسميات في النموذج كما يسمّيها الناس — فمرجع الطبلية صار «رمز الطبلية»، ورمز الصف صار «رمز الحجر». ودُمج الرقم الوطني للسائق مع رقمه الذكي في حقل واحد، ولم يعد يُطلب آيبان السائق ولا هاتف مسؤول التحميل ولا هاتف مندوب التخليص. وتحتفظ أي قائمة محفوظة قبل ذلك بكل ما حُفظ فيها.',
          fa: 'پکینگ لیست: نام فیلدهای فرم همان چیزی شد که مردم می‌گویند — «رفرنس» پالت حالا «کد پالت» است و «کد» هر ردیف «شناسه سنگ». کد ملی و شماره هوشمند راننده یک فیلد شدند، و شماره شبای راننده و شماره تلفن مسئول بارگیری و نمایندهٔ گمرک دیگر پرسیده نمی‌شوند. لیستی که پیش از این ذخیره شده، هر چه داشته نگه می‌دارد.',
        },
      },
    ],
  },
  {
    version: '1.8.7',
    date: '2026-10-24',
    changes: [
      {
        type: 'fixed',
        text: {
          en: 'Downloaded files now keep their format. A file you download from Files, from Raw Contents, or from any viewer or gallery in the app arrives with its proper extension (for example "Front view.jpg" instead of just "Front view"), so your computer knows what it is and opens it with the right program. Files inside a zip download are named the same way.',
          ar: 'الملفات المُنزَّلة تحتفظ الآن بصيغتها. فالملف الذي تنزّله من الملفات أو من المحتوى الخام أو من أي عارض أو معرض في التطبيق يصل بامتداده الصحيح (مثلاً «Front view.jpg» بدل «Front view» فقط)، فيعرف جهازك نوعه ويفتحه بالبرنامج المناسب. وتُسمّى الملفات داخل التنزيل المضغوط بالطريقة نفسها.',
          fa: 'فایل‌های دانلودشده اکنون فرمت خود را نگه می‌دارند. فایلی که از فایل‌ها، محتوای خام یا هر نمایشگر و گالری برنامه دانلود کنید با پسوند درستش می‌رسد (مثلاً «Front view.jpg» به‌جای «Front view» تنها)، پس سیستم شما نوع آن را می‌شناسد و با برنامهٔ مناسب بازش می‌کند. فایل‌های داخل دانلود فشرده هم همین‌طور نام‌گذاری می‌شوند.',
        },
      },
    ],
  },
  {
    version: '1.8.6',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Packing lists on a phone: the form, the record and the short-labels sheet are now laid out for a thumb. Buttons and arrows are larger, tapping a field no longer zooms the page in, the form ends with full-width Cancel and Save buttons, and the item table of a record fits the screen instead of being cut off.',
          ar: 'قوائم التعبئة على الهاتف: صُمّمت الآن واجهة النموذج والسجل وورقة الملصقات القصيرة للاستخدام بالإبهام. صارت الأزرار والأسهم أكبر، ولم يعد لمس أي حقل يكبّر الصفحة، وينتهي النموذج بزرّي إلغاء وحفظ بعرض كامل، ويتسع جدول البنود في السجل للشاشة بدل أن يُقطع.',
          fa: 'پکینگ لیست روی موبایل: فرم، صفحهٔ رکورد و برگهٔ برچسب‌های کوتاه اکنون برای انگشت شست چیده شده‌اند. دکمه‌ها و فلش‌ها بزرگ‌تر شدند، لمس یک فیلد دیگر صفحه را بزرگ نمی‌کند، پایین فرم دکمه‌های تمام‌عرض انصراف و ذخیره دارد و جدول اقلام رکورد به‌جای بریده‌شدن در عرض صفحه جا می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list form: typing in a pallet, and moving pallets, is much faster on long lists. Only the pallet you are changing is redrawn, so a list of 30 or more pallets no longer makes a phone wait after every key.',
          ar: 'نموذج قائمة التعبئة: صارت الكتابة في الطبلية ونقل الطبليات أسرع بكثير في القوائم الطويلة. فلا تُعاد رسم سوى الطبلية التي تغيّرها، ولم تعد قائمة من 30 طبلية أو أكثر تجعل الهاتف ينتظر بعد كل حرف.',
          fa: 'فرم پکینگ لیست: تایپ در یک پالت و جابه‌جایی پالت‌ها در لیست‌های بلند بسیار سریع‌تر شد. فقط پالتی که تغییر می‌دهید دوباره رسم می‌شود، پس در لیست ۳۰ پالتی یا بیشتر موبایل دیگر بعد از هر حرف منتظر نمی‌ماند.',
        },
      },
    ],
  },
  {
    version: '1.8.5',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Packing list form: pallets now move smoothly. A pallet you move slides to its new place, the pallet numbers roll to their new values, and a pallet you add or duplicate eases in while one you remove folds away. (Nothing moves if your device is set to reduce motion.)',
          ar: 'نموذج قائمة التعبئة: صارت حركة الطبليات انسيابية. فالطبلية التي تنقلها تنزلق إلى مكانها الجديد، وتتغير أرقام الطبليات بحركة ناعمة، والطبلية التي تضيفها أو تكرّرها تظهر بسلاسة، وتلك التي تحذفها تنطوي وتختفي. (ولا تتحرك العناصر إذا كان جهازك مضبوطًا على تقليل الحركة.)',
          fa: 'فرم پکینگ لیست: جابه‌جایی پالت‌ها اکنون روان است. پالتی که جابه‌جا می‌کنید به جای تازهٔ خود می‌لغزد، شمارهٔ پالت‌ها با حرکتی نرم عوض می‌شود، پالتی که اضافه یا کپی می‌کنید نرم ظاهر می‌شود و پالتی که حذف می‌کنید جمع می‌شود و از بین می‌رود. (اگر دستگاه شما روی کاهش حرکت تنظیم شده باشد، چیزی حرکت نمی‌کند.)',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Short labels sheet: the labels now always print on one side of the A4 page. (The \u201cBack to back\u201d option was removed.)',
          ar: 'ورقة الملصقات القصيرة: تُطبع الملصقات الآن دائمًا على وجه واحد من ورقة A4. (أُزيل خيار \u00abظهرًا لظهر\u00bb.)',
          fa: 'برگهٔ برچسب‌های کوتاه: برچسب‌ها اکنون همیشه روی یک طرف برگ A4 چاپ می‌شوند. (گزینهٔ \u00abپشت و رو\u00bb حذف شد.)',
        },
      },
    ],
  },
  {
    version: '1.8.4',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Printed invoices, quotations and packing lists are easier to read: larger, darker type and clearer lines. A document that runs onto more pages now continues complete — no row is cut in half — with its header repeated at the top of every page.',
          ar: 'الفواتير وعروض الأسعار وقوائم التعبئة المطبوعة أسهل قراءة: خط أكبر وأغمق وخطوط أوضح. وإذا امتد المستند إلى صفحات إضافية فإنه يُكمَل كاملًا — دون قطع أي صف إلى نصفين — مع تكرار الترويسة أعلى كل صفحة.',
          fa: 'فاکتورها، پیش‌فاکتورها و پکینگ لیست‌های چاپی خواناتر شدند: حروف درشت‌تر و پررنگ‌تر و خطوط واضح‌تر. اگر سند به چند صفحه برسد کامل ادامه پیدا می‌کند — هیچ ردیفی نصف نمی‌شود — و سربرگ در بالای هر صفحه تکرار می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The printed packing list no longer includes the per-pallet summary table — only the detailed list. Nothing was removed from the form or the saved data.',
          ar: 'لم يعد جدول ملخص الطبليات يظهر في طباعة قائمة التعبئة، ويبقى جدول التفاصيل فقط. ولم يُحذف شيء من النموذج أو من البيانات المحفوظة.',
          fa: 'جدول خلاصهٔ پالت‌ها دیگر در چاپ پکینگ لیست نمی‌آید و فقط جدول جزئیات می‌ماند. چیزی از فرم یا داده‌های ذخیره‌شده حذف نشده است.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Short pallet labels: print up to 5 on one A4 sheet. Pick the pallets, and switch on “Back to back” to print the same labels on both sides of the sheet.',
          ar: 'ملصقات الطبليات القصيرة: اطبع حتى 5 ملصقات على ورقة A4 واحدة. اختر الطبليات، وفعّل «ظهرًا لظهر» لطباعة الملصقات نفسها على وجهي الورقة.',
          fa: 'برچسب پالت کوتاه: تا 5 برچسب را روی یک برگ A4 چاپ کنید. پالت‌ها را انتخاب کنید و با گزینهٔ «پشت و رو» همین برچسب‌ها را در دو طرف برگه چاپ کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list: add the stone name — one or more — by picking it from Inventory or just typing it. It is printed on the list.',
          ar: 'قائمة التعبئة: أضف اسم الحجر — اسمًا واحدًا أو أكثر — باختياره من المخزون أو بكتابته مباشرة. ويُطبع في القائمة.',
          fa: 'پکینگ لیست: نام سنگ را — یک نام یا چند نام — از انبار انتخاب کنید یا مستقیم بنویسید. در لیست چاپ می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list form: the pallets are numbered, and you can change their order with the arrows or by typing a number. The printed list follows the same order.',
          ar: 'نموذج قائمة التعبئة: الطبليات مرقّمة، ويمكنك تغيير ترتيبها بالسهمين أو بكتابة رقم. وتتبع القائمة المطبوعة الترتيب نفسه.',
          fa: 'فرم پکینگ لیست: پالت‌ها شماره دارند و ترتیبشان را می‌توانید با فلش‌ها یا نوشتن یک عدد تغییر دهید. لیست چاپی همان ترتیب را دنبال می‌کند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'A packing list now has the copy-link button like the other sections. (Invoices and quotations already had theirs.)',
          ar: 'أصبح لقائمة التعبئة زر نسخ الرابط مثل بقية الأقسام. (والفواتير وعروض الأسعار لديها هذا الزر أصلًا.)',
          fa: 'پکینگ لیست هم مثل بخش‌های دیگر دکمهٔ کپی پیوند دارد. (فاکتورها و پیش‌فاکتورها از قبل داشتند.)',
        },
      },
    ],
  },
  {
    version: '1.8.3',
    date: '2026-10-20',
    changes: [
      {
        type: 'new',
        text: {
          en: 'New customer: start with a phone number OR any other way to reach them — WhatsApp, e-mail, Telegram or Instagram. The same duplicate check runs on whichever you enter first, so nobody is added twice.',
          ar: 'عميل جديد: ابدأ برقم الهاتف أو بأي وسيلة تواصل أخرى — واتساب أو البريد الإلكتروني أو تيليغرام أو إنستغرام. ويُجرى فحص التكرار نفسه على ما تُدخله أولًا، فلا يُضاف أحد مرتين.',
          fa: 'مشتری جدید: با شماره تلفن یا هر راه ارتباطی دیگر شروع کنید — واتساپ، ایمیل، تلگرام یا اینستاگرام. همان بررسی تکراری‌بودن روی اولین موردی که وارد می‌کنید انجام می‌شود تا کسی دوبار ثبت نشود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Every customer now has a type — Cash customer or Regular customer — right after the contact details, with the status beside it. A cash customer is always Won. The customer list can be filtered by type.',
          ar: 'لكل عميل الآن نوع — عميل نقدي أو عميل دائم — بعد بيانات التواصل مباشرة وبجانبه الحالة. حالة العميل النقدي دائمًا «مكتمل». ويمكن تصفية قائمة العملاء حسب النوع.',
          fa: 'هر مشتری اکنون یک نوع دارد — مشتری نقدی یا مشتری دائمی — درست بعد از اطلاعات تماس و وضعیت کنار آن. وضعیت مشتری نقدی همیشه «موفق» است. فهرست مشتریان را می‌توان بر اساس نوع فیلتر کرد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Sales report: one customer purchase can hold several kinds of stone, each with its own quantity and price (Add another stone). The order total adds them up and the printed sheet groups them under the customer. Reports filed before still open and print as they were.',
          ar: 'تقرير المندوب: يمكن أن يضم شراء العميل الواحد عدة أنواع من الرخام، لكل نوع كميته وسعره (إضافة نوع رخام آخر). ويجمع إجمالي الطلب الأنواع وتجمعها الورقة المطبوعة تحت العميل. والتقارير المرفوعة سابقًا تُفتح وتُطبع كما كانت.',
          fa: 'گزارش فروشنده: یک خرید مشتری می‌تواند چند نوع سنگ داشته باشد، هر کدام با مقدار و قیمت خودش (افزودن سنگ دیگر). جمع سفارش آن‌ها را جمع می‌زند و برگهٔ چاپی آن‌ها را زیر نام مشتری گروه‌بندی می‌کند. گزارش‌هایی که قبلاً ثبت شده‌اند مثل قبل باز و چاپ می‌شوند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Every stone tied to a customer in a daily report (confirmed or lost orders, customer requests) is added to that customer’s interested products when the report is filed.',
          ar: 'كل صنف يُربط بعميل في التقرير اليومي (الطلبات المؤكدة أو غير المتفق عليها أو طلبات العملاء) يُضاف إلى الأصناف المهتم بها لدى هذا العميل عند رفع التقرير.',
          fa: 'هر سنگی که در گزارش روزانه به مشتری وصل شود (سفارش قطعی، سفارش منتفی یا درخواست مشتری) هنگام ثبت گزارش به محصولات موردعلاقهٔ آن مشتری اضافه می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.2',
    date: '2026-10-20',
    changes: [
      {
        type: 'fixed',
        text: {
          en: 'Pallet labels now print at the real label size, A5 (148 × 210 mm), with large clear type like the sample: the header with the logo and both addresses, the pallet ID over its reference, the cuts in tall rows and the total. A pallet with many cuts continues on a second page instead of shrinking until it cannot be read.',
          ar: 'تُطبع ملصقات الطبليات الآن بحجمها الحقيقي A5 (148 × 210 مم) وبخط كبير وواضح كما في النموذج: الترويسة بالشعار والعنوانين، ورقم الطبلية فوق مرجعها، والقطع في صفوف عالية ثم الإجمالي. والطبلية ذات القطع الكثيرة تستمر في صفحة ثانية بدل أن يصغر الخط حتى يتعذر قراءته.',
          fa: 'برچسب پالت‌ها اکنون با اندازهٔ واقعی A5 (148 × 210 میلی‌متر) و با خط درشت و خوانا مانند نمونه چاپ می‌شود: سربرگ با لوگو و هر دو نشانی، شناسهٔ پالت بالای رفرنس آن، قطعه‌ها در ردیف‌های بلند و جمع. پالتی که قطعه‌های زیادی دارد به‌جای ریز شدن تا حد ناخوانایی، در صفحهٔ دوم ادامه می‌یابد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Customer forms: the city is now one select for every country, with each city’s province shown next to it — there is no separate province field. Type to search by city or by province. City and province names come from GeoNames (geonames.org), CC BY 4.0.',
          ar: 'نماذج العملاء: المدينة الآن قائمة اختيار واحدة لكل دولة، وتظهر محافظة كل مدينة بجانبها — ولا يوجد حقل منفصل للمحافظة. اكتب للبحث باسم المدينة أو المحافظة. أسماء المدن والمحافظات من GeoNames (geonames.org) برخصة CC BY 4.0.',
          fa: 'فرم مشتری: شهر اکنون برای هر کشور یک انتخابگر است و استان هر شهر کنار آن نشان داده می‌شود — فیلد جداگانه‌ای برای استان وجود ندارد. برای جست‌وجو نام شهر یا استان را بنویسید. نام شهرها و استان‌ها از GeoNames (geonames.org) با مجوز CC BY 4.0 است.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: every pallet needs its own ID and its own reference. Two pallets with the same reference (or ID) turn red and the list cannot be saved until it is fixed; the server refuses it too. A packing list number that is already used is flagged as you type.',
          ar: 'قوائم التعبئة: لكل طبلية رقمها ومرجعها الخاصان. إذا تشابه مرجع طبليتين (أو رقماهما) تتحول الحقول إلى الأحمر ولا يمكن حفظ القائمة حتى يُصحَّح ذلك، كما يرفضها الخادم. ويُنبَّه إلى رقم قائمة التعبئة المستخدم بالفعل أثناء الكتابة.',
          fa: 'پکینگ لیست: هر پالت باید شناسه و رفرنس خودش را داشته باشد. دو پالت با رفرنس (یا شناسهٔ) یکسان قرمز می‌شوند و تا اصلاح نشود لیست ذخیره نمی‌شود؛ سرور هم آن را نمی‌پذیرد. شمارهٔ پکینگ لیستی که قبلاً استفاده شده، هنگام تایپ علامت می‌خورد.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'The notes written on a packing list now appear on its printed page, and its coloured table headers print even when the browser’s “Background graphics” option is off.',
          ar: 'تظهر الآن ملاحظات قائمة التعبئة في صفحتها المطبوعة، كما تُطبع رؤوس جداولها الملونة حتى لو كان خيار «رسوم الخلفية» في المتصفح معطّلًا.',
          fa: 'یادداشت‌های نوشته‌شده روی پکینگ لیست اکنون در صفحهٔ چاپی آن دیده می‌شود و سربرگ‌های رنگی جدول‌هایش حتی وقتی گزینهٔ «Background graphics» مرورگر خاموش است چاپ می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.1',
    date: '2026-10-18',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Packing lists: the number is filled in automatically and you can change it — type your own on a new list, or renumber an existing one. A number cannot be used twice in a branch, and the automatic numbers carry on after the highest one you typed.',
          ar: 'قوائم التعبئة: يُعبأ الرقم تلقائيًا ويمكنك تغييره — اكتب رقمك الخاص في قائمة جديدة أو أعد ترقيم قائمة موجودة. لا يمكن استخدام الرقم مرتين في الفرع الواحد، وتستمر الأرقام التلقائية بعد أعلى رقم كتبته.',
          fa: 'پکینگ لیست: شماره خودکار پر می‌شود و می‌توانید آن را تغییر دهید — در لیست جدید شمارهٔ دلخواه بنویسید یا لیست موجود را شمارهٔ دیگری بدهید. یک شماره در یک شعبه دوبار استفاده نمی‌شود و شماره‌های خودکار بعد از بالاترین شمارهٔ دستی ادامه می‌یابند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The packing list number now stands out at the top of the printed packing list.',
          ar: 'يظهر رقم قائمة التعبئة الآن بوضوح أعلى قائمة التعبئة المطبوعة.',
          fa: 'شمارهٔ پکینگ لیست اکنون در بالای پکینگ لیست چاپی برجسته دیده می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.0',
    date: '2026-10-18',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Invoices, quotes, stock requests and packing lists keep an unsent draft while you fill them in. If the page closes or crashes, continue from the list; closing a form asks whether to keep the draft.',
          ar: 'تحتفظ الفواتير وعروض الأسعار وطلبات المخزون وقوائم التعبئة بمسودة غير مُرسلة أثناء تعبئتها. إن أُغلقت الصفحة أو تعطّلت فتابع من القائمة، وعند إغلاق النموذج يُسأل إن كنت تريد الاحتفاظ بالمسودة.',
          fa: 'فاکتورها، پیش‌فاکتورها، درخواست‌های موجودی و پکینگ لیست‌ها هنگام پر کردن، یک پیش‌نویس ارسال‌نشده نگه می‌دارند. اگر صفحه بسته شود یا خراب شود از همان فهرست ادامه دهید؛ هنگام بستن فرم هم پرسیده می‌شود که پیش‌نویس نگه داشته شود یا نه.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Pick the calendar of every invoice, quote, request and packing list — Gregorian, Shamsi (Persian) or Hijri (Arabic). The date is entered and printed in that calendar, and each branch can set its own default in People → Branches.',
          ar: 'اختر تقويم كل فاتورة وعرض سعر وطلب وقائمة تعبئة — ميلادي أو شمسي (فارسي) أو هجري (عربي). يُدخل التاريخ ويُطبع بذلك التقويم، ويمكن لكل فرع تحديد تقويمه الافتراضي من المستخدمون ← الفروع.',
          fa: 'تقویم هر فاکتور، پیش‌فاکتور، درخواست و پکینگ لیست را انتخاب کنید — میلادی، شمسی یا هجری قمری. تاریخ با همان تقویم وارد و چاپ می‌شود و هر شعبه می‌تواند تقویم پیش‌فرض خودش را در کاربران ← شعبه‌ها تعیین کند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Write any invoice or quote in dirhams, Saudi riyals, Iranian rials, US dollars or euros. Totals and the Arabic amount in words follow the currency, and each branch can set its default currency. Prices are never converted automatically.',
          ar: 'اكتب أي فاتورة أو عرض سعر بالدرهم أو الريال السعودي أو الريال الإيراني أو الدولار الأمريكي أو اليورو. تتبع الإجماليات والمبلغ كتابةً العملة، ويمكن لكل فرع تحديد عملته الافتراضية. لا تُحوَّل الأسعار تلقائيًا أبدًا.',
          fa: 'هر فاکتور یا پیش‌فاکتور را به درهم، ریال عربستان، ریال ایران، دلار آمریکا یا یورو بنویسید. جمع‌ها و مبلغ به حروف عربی با واحد پول هماهنگ می‌شوند و هر شعبه می‌تواند واحد پول پیش‌فرضش را تعیین کند. قیمت‌ها هرگز خودکار تبدیل نمی‌شوند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'External link pages: give every link its own title — for example "Contact us" for the English salesperson and «تواصل معنا» for the Arabic one. The title is the main text visitors read on the page.',
          ar: 'صفحات الروابط الخارجية: أعطِ كل رابط عنوانه الخاص — مثل «Contact us» لمندوب المبيعات الإنجليزي و«تواصل معنا» للمندوب العربي. العنوان هو النص الرئيسي الذي يقرؤه الزوار في الصفحة.',
          fa: 'صفحه‌های لینک بیرونی: برای هر لینک عنوان جداگانه بگذارید — مثلاً «Contact us» برای فروشندهٔ انگلیسی‌زبان و «تواصل معنا» برای فروشندهٔ عرب‌زبان. عنوان، متن اصلی‌ای است که بازدیدکننده‌ها در صفحه می‌خوانند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'In every form, the Up and Down arrow keys move between fields; Left and Right move too when the cursor is at the edge of the text.',
          ar: 'في كل نموذج، تنقلك مفتاحا السهم لأعلى ولأسفل بين الحقول؛ ويتنقل السهمان الأيمن والأيسر أيضًا عندما يكون المؤشر عند طرف النص.',
          fa: 'در همهٔ فرم‌ها، کلیدهای جهت بالا و پایین بین فیلدها جابه‌جا می‌شوند؛ چپ و راست هم وقتی مکان‌نما در لبهٔ متن است جابه‌جا می‌کنند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Arabic text now uses the Amiri font and Persian text uses B Nazanin, on screen and on printed documents.',
          ar: 'يستخدم النص العربي الآن خط «أميري» ويستخدم النص الفارسي خط «بي نازنين»، على الشاشة وفي المستندات المطبوعة.',
          fa: 'متن عربی اکنون با فونت «امیری» و متن فارسی با فونت «بی نازنین» نمایش داده می‌شود، هم روی صفحه و هم در اسناد چاپی.',
        },
      },
    ],
  },
  {
    version: '1.7.1',
    date: '2026-10-17',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Report & Info: edit a report you sent while it is still Open — change the text, add or remove files and voice notes — and delete reports you no longer need.',
          ar: 'الإبلاغ والمعلومات: عدّل بلاغًا أرسلته ما دام مفتوحًا — غيّر النص وأضف الملفات والمذكرات الصوتية أو أزلها — واحذف البلاغات التي لم تعد بحاجة إليها.',
          fa: 'گزارش و اطلاعات: گزارشی را که فرستاده‌اید تا وقتی «باز» است ویرایش کنید — متن را عوض کنید، فایل و پیام صوتی اضافه یا حذف کنید — و گزارش‌هایی را که دیگر لازم ندارید حذف کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'You are now notified when the status of your report changes or someone answers it, and the answer is shown on the report itself.',
          ar: 'يصلك الآن إشعار عند تغيّر حالة بلاغك أو عند الردّ عليه، ويظهر الردّ على البلاغ نفسه.',
          fa: 'اکنون وقتی وضعیت گزارش شما تغییر کند یا کسی به آن پاسخ دهد اعلان می‌گیرید و پاسخ روی خود گزارش دیده می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.7.0',
    date: '2026-10-17',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Report & Info: see the app version, every section and what changed recently — and report a bug or suggest an idea with text, a voice note and files, then follow its status.',
          ar: 'الإبلاغ والمعلومات: اطّلع على إصدار التطبيق وكل الأقسام وآخر التغييرات، وأبلغ عن مشكلة أو اقترح فكرة بالنص أو بمذكرة صوتية أو بملفات، ثم تابع حالتها.',
          fa: 'گزارش و اطلاعات: نسخهٔ برنامه، همهٔ بخش‌ها و تازه‌ترین تغییرات را ببینید؛ مشکلی را گزارش دهید یا پیشنهادی بدهید (با متن، پیام صوتی و فایل) و وضعیتش را دنبال کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Digital Marketing keeps an unsent draft of your upload form. If the page closes or crashes, pick up where you left off — and a Reset button clears the form.',
          ar: 'يحتفظ التسويق الرقمي بمسودة غير مُرسلة لنموذج الرفع. إن أُغلقت الصفحة أو تعطّلت فتابع من حيث توقفت، وزر «إعادة تعيين» يمسح النموذج.',
          fa: 'بازاریابی دیجیتال از فرم بارگذاری شما یک پیش‌نویس ارسال‌نشده نگه می‌دارد. اگر صفحه بسته شود یا خراب شود، از همان‌جا ادامه دهید؛ دکمهٔ «بازنشانی» هم فرم را پاک می‌کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'When an upload is refused, the message now says why — for example, that the file is larger than the server accepts.',
          ar: 'عند رفض أي رفع، توضّح الرسالة الآن السبب — مثلًا أن الملف أكبر مما يقبله الخادم.',
          fa: 'وقتی بارگذاری رد می‌شود، پیام اکنون دلیلش را می‌گوید؛ مثلاً اینکه فایل از حدِ پذیرش سرور بزرگ‌تر است.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Pallet and stone-size fields are easier to read and type in, on phones and computers alike.',
          ar: 'أصبحت حقول المشاحنات وأبعاد الحجر أسهل في القراءة والكتابة على الهواتف وأجهزة الكمبيوتر.',
          fa: 'فیلدهای پالت و ابعاد سنگ هم روی گوشی و هم روی کامپیوتر خواناتر و راحت‌تر قابل تایپ شده‌اند.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Photos and videos now show up in Digital Marketing raw contents, and opening a draft that held a very large file no longer fails.',
          ar: 'تظهر الصور ومقاطع الفيديو الآن في المحتوى الخام بالتسويق الرقمي، ولم يعد فتح مسودة تحتوي على ملف كبير جدًا يفشل.',
          fa: 'عکس‌ها و ویدیوها اکنون در محتوای خام بازاریابی دیجیتال دیده می‌شوند و باز کردن پیش‌نویسی که فایل بسیار بزرگ دارد دیگر خطا نمی‌دهد.',
        },
      },
    ],
  },
  {
    version: '1.6.0',
    date: '2026-10-14',
    changes: [
      {
        type: 'new',
        text: {
          en: 'A daily report form for each role. Salespeople get their own sheet — customers from the CRM, stone codes from Inventory, content from Digital Marketing — saved as you type and printable in Arabic, English or Farsi.',
          ar: 'نموذج تقرير يومي لكل دور. يحصل مندوبو المبيعات على ورقتهم الخاصة — العملاء من إدارة العملاء، وأكواد الحجر من المخزون، والمحتوى من التسويق الرقمي — تُحفظ أثناء الكتابة ويمكن طباعتها بالعربية أو الإنجليزية أو الفارسية.',
          fa: 'فرم گزارش روزانه برای هر نقش. فروشندگان برگهٔ مخصوص خودشان را دارند — مشتریان از بخش مشتریان، کد سنگ از انبار، محتوا از بازاریابی دیجیتال — که هنگام تایپ ذخیره می‌شود و به فارسی، عربی یا انگلیسی قابل چاپ است.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Customers added without a branch are visible again in the customer list.',
          ar: 'عاد ظهور العملاء الذين أُضيفوا دون فرع في قائمة العملاء.',
          fa: 'مشتریانی که بدون شعبه اضافه شده‌اند دوباره در فهرست مشتریان دیده می‌شوند.',
        },
      },
    ],
  },
  {
    version: '1.5.0',
    date: '2026-10-07',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Website price requests become expiring offers: priced in Invoices, e-mailed to the customer, accepted on the website, and turned into an invoice.',
          ar: 'أصبحت طلبات الأسعار من الموقع عروضًا ذات مدة محدودة: تُسعَّر في الفواتير، وتُرسل بالبريد إلى العميل، ويقبلها على الموقع، وتتحول إلى فاتورة.',
          fa: 'درخواست‌های قیمت از وب‌سایت به پیشنهادهای دارای مهلت تبدیل شد: در فاکتورها قیمت‌گذاری می‌شود، با ایمیل برای مشتری می‌رود، مشتری در وب‌سایت می‌پذیرد و به فاکتور تبدیل می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Find a stone variety by its specification — quality, size, cut and finish — in invoices, stock requests, supply and packing lists.',
          ar: 'ابحث عن صنف الحجر بمواصفاته — الجودة والمقاس والقطع والتشطيب — في الفواتير وطلبات المخزون والتوريد وقوائم التعبئة.',
          fa: 'تنوع سنگ را با مشخصاتش — کیفیت، اندازه، برش و پرداخت — در فاکتورها، درخواست‌های انبار، تأمین و لیست‌های بسته‌بندی پیدا کنید.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The product page editor shows the real website page as you type, with a proper image gallery manager.',
          ar: 'يعرض محرر صفحة المنتج صفحة الموقع الحقيقية أثناء الكتابة، مع مدير معرض صور متكامل.',
          fa: 'ویرایشگر صفحهٔ محصول هنگام تایپ، صفحهٔ واقعی وب‌سایت را نشان می‌دهد و مدیریت گالری تصاویر هم دارد.',
        },
      },
    ],
  },
  {
    version: '1.4.0',
    date: '2026-10-03',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Branches can share their inventory with other branches (read-only) and receive stock requests.',
          ar: 'يمكن للفروع مشاركة مخزونها مع فروع أخرى (للعرض فقط) واستقبال طلبات المخزون.',
          fa: 'شعبه‌ها می‌توانند انبار خود را (فقط برای مشاهده) با شعبه‌های دیگر به اشتراک بگذارند و درخواست موجودی دریافت کنند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Accepting a quotation now reserves the stone, and paying an invoice takes it out of stock.',
          ar: 'قبول عرض السعر يحجز الحجر الآن، ودفع الفاتورة يخرجه من المخزون.',
          fa: 'پذیرفتن پیش‌فاکتور اکنون سنگ را رزرو می‌کند و پرداخت فاکتور آن را از انبار خارج می‌کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Sign in with your phone number and password.',
          ar: 'سجّل الدخول برقم هاتفك وكلمة المرور.',
          fa: 'با شماره تلفن و رمز عبور وارد شوید.',
        },
      },
    ],
  },
  {
    version: '1.3.0',
    date: '2026-09-26',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Supply: follow a stone coupe from purchase, through processing, to finished product.',
          ar: 'التوريد: تابع كتلة الحجر من الشراء، مرورًا بالمعالجة، حتى المنتج النهائي.',
          fa: 'تأمین: یک قواره سنگ را از خرید، در طول فرآوری، تا محصول نهایی دنبال کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Inter-branch quotations: one branch can quote against another branch’s inventory or supply.',
          ar: 'عروض أسعار بين الفروع: يمكن لفرع أن يُسعّر من مخزون فرع آخر أو من توريده.',
          fa: 'پیش‌فاکتور بین شعبه‌ها: یک شعبه می‌تواند بر اساس انبار یا تأمین شعبهٔ دیگر پیش‌فاکتور بدهد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists are their own section now, with printable pallet labels.',
          ar: 'أصبحت قوائم التعبئة قسمًا مستقلًا، مع ملصقات مشاحنات قابلة للطباعة.',
          fa: 'لیست‌های بسته‌بندی اکنون بخش مستقل دارند و برچسب پالت قابل چاپ هم دارند.',
        },
      },
    ],
  },
  {
    version: '1.2.0',
    date: '2026-08-28',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Tutorials: short videos, images and steps for every part of the app, with a help button inside each section.',
          ar: 'الدروس التعليمية: مقاطع فيديو وصور وخطوات قصيرة لكل جزء من التطبيق، مع زر مساعدة داخل كل قسم.',
          fa: 'آموزش‌ها: ویدیو، تصویر و مراحل کوتاه برای هر بخش برنامه، با دکمهٔ راهنما در هر بخش.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Digital Marketing: link pages you can share with customers, and WhatsApp Share with messages in several languages and a history of what was sent.',
          ar: 'التسويق الرقمي: صفحات روابط يمكن مشاركتها مع العملاء، ومشاركة واتساب برسائل بعدة لغات وسجل بما أُرسل.',
          fa: 'بازاریابی دیجیتال: صفحات پیوند برای اشتراک با مشتریان، و اشتراک‌گذاری واتس‌اپ با پیام چندزبانه و تاریخچهٔ آنچه فرستاده شده.',
        },
      },
    ],
  },
  {
    version: '1.1.0',
    date: '2026-07-24',
    changes: [
      {
        type: 'new',
        text: {
          en: 'The whole app in English, Farsi and Arabic — switch language from the side menu.',
          ar: 'التطبيق كاملًا بالعربية والإنجليزية والفارسية — بدّل اللغة من القائمة الجانبية.',
          fa: 'کل برنامه به فارسی، عربی و انگلیسی — زبان را از منوی کناری عوض کنید.',
        },
      },
    ],
  },
  {
    version: '1.0.0',
    date: '2026-07-12',
    changes: [
      {
        type: 'new',
        text: {
          en: 'First release: Customers, Invoices, Inventory, Files, People and Digital Marketing.',
          ar: 'الإصدار الأول: العملاء والفواتير والمخزون والملفات والمستخدمون والتسويق الرقمي.',
          fa: 'نخستین نسخه: مشتریان، فاکتورها، انبار، فایل‌ها، کاربران و بازاریابی دیجیتال.',
        },
      },
    ],
  },
];

export const APP_VERSION = CHANGELOG[0].version;
export const APP_RELEASED = CHANGELOG[0].date;

// A change's text in the person's language, English if it was never written.
export const changeText = (change, language) => (change.text && (change.text[language] || change.text.en)) || '';
